import Image, { ImageProps } from '@/components/atoms/image/image';
import Button from '@/components/molecules/button/button';
import styles from './media-slider-item.module.scss';

export type MediaSliderItemProps = Content.Properties.ImageAndVideoGridItem & {
  /** The aspect ratio of the image */
  aspectRatio?: ImageProps['aspectRatio'];
  /** The text to display on a backdrop */
  backdropText?: string;
  /** The callback to handle the click event */
  onClick?: (id: string) => void;
  /** Indicates whether the image should be loaded immediately */
  priority?: boolean;
  /** The sizes of the image */
  sizes?: ImageProps['sizes'];
};

const MediaSliderItem = (props: MediaSliderItemProps) => {
  const isVideo = 'video' in props;
  let image: Content.Properties.Image;

  if (isVideo) {
    image = props.video.thumbnailImage;
  } else {
    image = props.image;
  }

  return (
    <div className={styles.component}>
      <div className={styles.imageWrapper}>
        <Image
          alt={image.altText}
          aspectRatio="oneByOne"
          fill
          height={343}
          priority={props.priority}
          src={image.url}
          srcSet={{
            desktop: {
              height: 656,
              width: 656,
            },
            laptop: {
              height: 464,
              width: 464,
            },
            tablet: {
              height: 348,
              width: 348,
            },
          }}
          unoptimized
          width={343}
        />
      </div>

      {isVideo && (
        <Button
          className={styles.button}
          icon="Play"
          iconSize={14}
          variant="primary"
        />
      )}
    </div>
  );
};

MediaSliderItem.displayName = 'MediaSliderItem';

export default MediaSliderItem;
